'use client'

import { sendGTMEvent } from '@next/third-parties/google'
import { useEffect } from 'react'

type Props = {
  event: string
  values: any
}

// Module scope preserves de-duplication when a sender unmounts and remounts.
const sentEventNames = new Set<string>()

export default function GtmEventSender({ event, values }: Props) {
  useEffect(() => {
    if (sentEventNames.has(event)) return

    sentEventNames.add(event)
    sendGTMEvent({ event, ...values })
  }, [event, values])

  return null
}
